import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { OrganizationPage } from "./ui";

export function OrganizationPageRoute(...rest: RouteObject[]): RouteObject {
  return {
    path: routes.organization(),
    element: createElement(OrganizationPage),
    children: rest,
  };
}
